export const REQUEST_CHECK_OUT_PASSENGER = 'REQUEST_CHECK_OUT_PASSENGER'

interface DataInterface {
  passengerId: string
  flightId: string
}

export default (data: DataInterface) => ({
  type: REQUEST_CHECK_OUT_PASSENGER,
  data,
})
